import React, { useState, useCallback, useEffect, useRef } from "react";

import TemplateTable from "../../components/TemplateTable";
import { ITableAppRender } from "../../components/TableApp";

import CadastrarProduto from "./CadastrarProduto";
import NumberFormat from "../../Utils/NumberFormat";
import { Label } from "semantic-ui-react";
import ProdutoRepository, { IProdutoListModel } from "../../Repositories/ProdutoRepository";
import errors from "../../Utils/ExtractErrors";
import { toast } from "react-toastify";
import { ISearch } from "../../components/Search";
import { ISearchResponse } from "../../interfaces";
import { IFields } from "../../components/Search/FilterBuilder";


const Products: React.FC = () => {

    const [list, setList] = useState<IProdutoListModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    const setStatus = (status: number) => {
        if (status)
            return <Label ribbon icon="check" color="pink" content="ATI" />
        else
            return <Label ribbon icon="times" color="grey" content="INA" />
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Status",
            content: (x: IProdutoListModel) => setStatus(x.status),
            textAlign: "left",
            width: 1
        },
        {
            header: "Código",
            content: (x: IProdutoListModel) => x.codigo,
            textAlign: "center",
            width: 1
        },
        {
            header: "Categoria",
            content: (x: IProdutoListModel) => x.categoria,
            width: 2
        },
        {
            header: "Nome",
            content: (x: IProdutoListModel) => x.nome,
            width: 7
        },
        {
            header: "Valor",
            content: (x: IProdutoListModel) => NumberFormat.Currency(x.valor),
            textAlign: "center",
            width: 2
        },
    ];

    const load = useCallback(async () => {
        setLoading(true);
        try {

            let response: ISearchResponse<IProdutoListModel>;

            if (refSearch.current.type === "simples") {
                response = await ProdutoRepository.List({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            } else {
                response = await ProdutoRepository.List({
                    filter: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setList(response.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }, []);

    const onChangeRecords = (value: number) => {
        refRecordsByPage.current = value;
        load();
    }

    const onPageChange = (pageNumber: string | number | undefined) => {
        refPageNumber.current = pageNumber;
        load();
    }

    const onSearch = ({ searchString, type }: ISearch) => {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;

        load();
    }

    useEffect(() => { load() }, [load]);

    const fields: IFields[] = [
        { label: "Nome", name: "Nome", type: "string", roles: ["Admin", "Operador"] },
        { label: "Categoria", name: "Categoria.Nome", type: "string", roles: ["Admin", "Operador"] },
        { label: "Codigo", name: "Codigo", type: "string", roles: ["Admin", "Operador"] },
        { label: "Valor", name: "Valor", type: "number", roles: ["Admin", "Operador"] },
        {
            label: "Status",
            name: "Status",
            type: "enum",
            values: [
                { key: "INA", text: "INA", value: 0, label: { icon: "times", color: "grey", content: "INA" } },
                { key: "ATI", text: "ATI", value: 1, label: { icon: "check", color: "pink", content: "ATI" } }
            ],
            roles: ["Admin", "Operador"]
        }
    ];

    return (
        <TemplateTable
            title="Produtos"
            icon="gem"
            insert={<CadastrarProduto onSuccess={load} />}
            tableRender={tableRender}
            tableList={list}
            searchPlaceHolder="Nome"
            onSearch={onSearch}
            filterFields={fields}
            tableLoading={loading}
            tablePagination={{
                currentPage: refPageNumber.current,
                totalRecords: refTotalRecords.current,
                totalPages: refTotalPages.current,
                onPageChange: onPageChange
            }}
            tableOnChangeRecords={onChangeRecords}
        />
    );
};

export default Products;
